module.exports = __webpack_public_path__ + "img/category5.406bfd2b.jpg";